// @theme component
import { useCallback, useEffect } from 'react';
import { pick } from 'ramda';
import { useAppSelector } from '@core/js/store/hooks';
import { getScript } from '@core/js/utils/scripts.util';

export const useFidoAuth = () => {
    const { ssoPasDomain } = useAppSelector(pick(['ssoPasDomain']));

    const fetchFidoAuth = useCallback(async () => {
        await getScript(`https://${ssoPasDomain}/jswrapper/fidoAuth.js`)
            .catch((e) => console.error(e));
    }, [ssoPasDomain]);

    useEffect(() => {
        if (!ssoPasDomain) {
            return;
        }

        fetchFidoAuth();
    }, [ssoPasDomain, fetchFidoAuth]);
};
